<template>
    <v-dialog 
        v-model="dialog" 
        max-width="600px">
        <template v-slot:activator="{ on }">
            <!-- <v-list-item v-on="on">
                <v-list-item-action>
                    <v-icon>mdi-pencil</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                    Appearance
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item> -->

            <v-btn 
                :disabled="loading != null" 
                icon
                v-on="on">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on">mdi-shape</v-icon>
                    </template>
                    <span>Appearance</span>
                </v-tooltip>
            </v-btn>
            <!-- <v-btn text v-on="on">Appearance</v-btn>
            <v-btn icon v-on="on"><v-icon>mdi-shape</v-icon></v-btn> -->
        </template>
        <v-card :loading="loading">
            <v-toolbar class="mb-6">
                <v-toolbar-title>
                    Appearance
                </v-toolbar-title>
                <template slot="extension">
                    <v-tabs
                        align-with-title
                        show-arrows
                        v-model="tab">
                        <v-tab>Point</v-tab>
                        <v-tab>Parallel Coordinates</v-tab>
                        <v-tab>Image</v-tab>
                    </v-tabs>
                </template>

            </v-toolbar>
            <v-card-text>
                <v-tabs-items 
                    v-model="tab"
                    class="mb-4">
                    <v-tab-item>
                        <v-slider 
                            v-model="scale" 
                            min=.1
                            max=2
                            step=.1
                            ticks
                            label="Scale" 
                            prepend-icon="mdi-image-size-select-small">
                            <template v-slot:append>
                                <v-text-field 
                                    v-model="scale" 
                                    class="mt-0 pt-0" 
                                    hide-details 
                                    single-line 
                                    min=.1
                                    max=2
                                    step=.1
                                    type="number" 
                                    style="width: 60px">
                                </v-text-field>
                            </template>
                        </v-slider>
                    </v-tab-item>
                    <v-tab-item>
                        <v-slider 
                            v-model="scale" 
                            min=.1
                            max=2
                            step=.1
                            ticks
                            label="Scale" 
                            prepend-icon="mdi-image-size-select-small">
                            <template v-slot:append>
                                <v-text-field 
                                    v-model="scale" 
                                    class="mt-0 pt-0" 
                                    hide-details 
                                    single-line 
                                    min=.1
                                    max=2
                                    step=.1
                                    type="number" 
                                    style="width: 60px">
                                </v-text-field>
                            </template>
                        </v-slider>
                        <v-slider ref="width_slider"
                                v-model="width" 
                                min="1" 
                                :max="max_size" 
                                label="Width" 
                                prepend-icon="mdi-arrow-expand-horizontal">
                                <template v-slot:append>
                                    <v-text-field 
                                        v-model="width" 
                                        suffix="px" 
                                        class="mt-0 pt-0" 
                                        hide-details 
                                        single-line 
                                        min=1
                                        :max="max_size" 
                                        step=1
                                        type="number" 
                                        style="width: 60px">
                                    </v-text-field>
                                </template>
                            </v-slider>
                            <v-slider ref="height_slider"
                                v-model="height" 
                                min="1" 
                                :max="max_size"
                                label="Height" 
                                prepend-icon="mdi-arrow-expand-vertical">
                                <template v-slot:append>
                                    <v-text-field 
                                        v-model="height" 
                                        suffix="px" 
                                        class="mt-0 pt-0" 
                                        hide-details 
                                        single-line 
                                        min=1
                                        :max="max_size"
                                        step=1
                                        type="number" 
                                        style="width: 60px">
                                    </v-text-field>
                                </template>
                            </v-slider>
                            <!-- <v-radio-group ref="orientation_switch"
                                v-model="orientation"
                                label="Orientation"
                                mandatory
                                prepend-icon="mdi-rotate-right">
                                <v-radio label="horizontal" value="horizontal"></v-radio>
                                <v-radio label="vertical" value="vertical"></v-radio>
                            </v-radio-group> -->
                    </v-tab-item>
                    <v-tab-item><v-slider 
                            v-model="scale" 
                            min=.1
                            max=2
                            step=.1
                            ticks
                            label="Scale" 
                            prepend-icon="mdi-image-size-select-small">
                            <template v-slot:append>
                                <v-text-field 
                                    v-model="scale" 
                                    class="mt-0 pt-0" 
                                    hide-details 
                                    single-line 
                                    min=.1
                                    max=2
                                    step=.1
                                    type="number" 
                                    style="width: 60px">
                                </v-text-field>
                            </template>
                        </v-slider>
                        <v-slider ref="width_slider"
                                v-model="width" 
                                min="1"  
                                :max="max_size"
                                label="Width" 
                                prepend-icon="mdi-arrow-expand-horizontal">
                                <template v-slot:append>
                                    <v-text-field 
                                        v-model="width" 
                                        suffix="px" 
                                        class="mt-0 pt-0" 
                                        hide-details 
                                        single-line 
                                        min=1
                                        :max="max_size"
                                        step=1
                                        type="number" 
                                        style="width: 60px">
                                    </v-text-field>
                                </template>
                            </v-slider>
                            <v-slider ref="height_slider"
                                v-model="height" 
                                min="1" 
                                :max="max_size"
                                step=1
                                label="Height" 
                                prepend-icon="mdi-arrow-expand-vertical">
                                <template v-slot:append>
                                    <v-text-field 
                                        v-model="height" 
                                        suffix="px" 
                                        class="mt-0 pt-0" 
                                        hide-details 
                                        single-line 
                                        min=1
                                        :max="max_size"
                                        step=1
                                        type="number" 
                                        style="width: 60px">
                                    </v-text-field>
                                </template>
                            </v-slider>
                    </v-tab-item>
                    <v-select 
                        v-model='colorscale'
                        :items="['categorical', 'single hue', 'rainbow']">

                    </v-select>
                    <v-color-picker 
                        v-if="colorscale == 'single hue'" 
                        v-model="single_hue"
                        width="573px"
                        hide-inputs
                        flat
                        @input="set_label_color('single hue')"/>
                </v-tabs-items>
                
                
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer />
                <v-btn text @click="dialog = false">Cancel</v-btn>
                <v-btn 
                    depressed 
                    @click="confirm_dialog" 
                    color="primary"
                    :loading="loading">
                    OK
                </v-btn>
            </v-card-actions>

        </v-card>
    </v-dialog>
</template>

<script>
/* import { mapState, mapActions } from "vuex";
 */

export default {
    name: "appearance-dialog",
    data: function() {
        return {
            dialog: false,
            single_hue: "#daa520"
        }
    },
    computed: {
        appearance: {
            get: function() {
                const appearance = this.$store.state.appearance;
                this.tab = {"point": 0, "parallel coordinates": 1, "image": 2}[appearance.pointtype]
                return appearance;
            }
        },
        max_size: {
            get: function() {
                const data = this.$store.state.data;
                if (data.size)
                    return data.size[0];
                else 
                    return 28
            }
        },
        width: {
            get: function() {
                return this.appearance.width;
            },
            set: function(width) {
                this.$store.commit("set_width", width);
            }
        },
        height: {
            get: function() {
                return this.appearance.height;
            },
            set: function(height) {
                this.$store.commit("set_height", height);
            }
        },
        scale: {
            get: function() {
                return this.appearance.scale;
            },
            set: function(scale) {
                this.$store.commit("set_scale", scale);
            }
        },
        orientation: {
            get: function() {
                return this.appearance.orientation || "horizontal";
            },
            set: function(orientation) {
                this.$store.commit("set_orientation", orientation);
            }
        },
        tab: {
            get: function() {
                return {"point": 0, "parallel coordinates": 1, "image": 2}[this.appearance.pointtype];
            },
            set: function(pointtype) {
                this.$store.commit("set_pointtype", ["point", "parallel coordinates", "image"][pointtype]);
            }
        },
        colorscale: {
            get: function() {
                return this.appearance.colorscale;
            },
            set: function(colorscale_type) {
                this.appearance.colorscale = colorscale_type;
                this.set_label_color(colorscale_type);
            }
        },
        loading: {
            get: function() {
                return this.$store.state.loading;
            },
            set: function(value) {
                this.$store.commit("set_loading", value);
            }
        },
    },
    methods: {
        confirm_dialog() {
            this.dialog = false;
        },
        set_label_color(type) {
            const color = this.single_hue;
            this.$store.commit("set_label_color", [type, color])
        },
    }
    
}
</script>